<template>
    <div class="supportedCards">
        <img src="@/assets/images/logos/logo-MasterCard.svg" alt="Master card logo">
        <img src="@/assets/images/logos/logo-Visa.png" alt="visa card logo">
        <img src="@/assets/images/logos/logo-paypal.png" alt="Pay Pal card logo" v-if="isDEU">
    </div>
</template>

<script>

export default {
    name: 'SupportedCards',
    computed: {
        isDEU() {
            return this.$store.getters['localisation/isDEU'];
        },
    },
};
</script>

<style lang="scss" scoped>
.supportedCards {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        margin: 0 0.25rem;
        height: 50px;
        width: auto;
    }
}
</style>
